module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/alarm-clock-44aa503e1546cf4f0b3422081fc5562d.svg";